import { useIsDesktopViewport } from '@ui/shared/viewport/useIsDesktopViewport';
import { ObjectivesScreenDesktop } from '@ui/desktop/objectives/ObjectivesScreen.desktop';
import { ObjectivesScreenPhone } from '@ui/phone/objectives/ObjectivesScreen.phone';

/**
 * `ObjectivesScreen` — the switch component (design/screens/objectives.md
 * v2.0 §10, responsive-strategy.md §2.2). The ONLY Objectives import
 * `App.tsx` uses. Picks the phone- or desktop-shaped tree at runtime via
 * `useIsDesktopViewport()`, same mechanism as Rewards/Weekly Review — both
 * trees ship together (responsive-strategy.md's standing rule) since
 * objective management already lives on the phone today
 * (phase-2d-management-history.md §2.1).
 *
 * Both trees consume the same domain layer/contracts; only the render tree
 * forks here. Neither tree is imported anywhere else in the app.
 */
export function ObjectivesScreen({
  onOpenObjective,
  onCreateObjective,
  onBack,
}: {
  readonly onOpenObjective: (objectiveId: string) => void;
  readonly onCreateObjective: () => void;
  readonly onBack?: () => void;
}) {
  const isDesktop = useIsDesktopViewport();
  return isDesktop ? (
    <ObjectivesScreenDesktop onOpenObjective={onOpenObjective} onCreateObjective={onCreateObjective} onBack={onBack} />
  ) : (
    <ObjectivesScreenPhone onOpenObjective={onOpenObjective} onCreateObjective={onCreateObjective} onBack={onBack} />
  );
}
